import { render, staticRenderFns } from "./AddebitoSpesaDialog.vue?vue&type=template&id=2a230249"
import script from "./AddebitoSpesaDialog.vue?vue&type=script&lang=js"
export * from "./AddebitoSpesaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports